if (!customElements.get('grid-services-items')) {
    class GridServicesItems extends HTMLElement {
        constructor() {
            super();
            this.wrapper = this.querySelector('.service-details__wrapper');
            this.onClick = this.onClick.bind(this);
        }

        connectedCallback() {
            this.addEventListener('click', this.onClick);
        }

        disconnectedCallback() {
            this.removeEventListener('click', this.onClick);
            this.closeQuickView();
        }

        onClick(event) {
            const openTrigger = event.target.closest('.quick-view__target[data-target]');
            const closeTrigger = event.target.closest('[data-service-quick-view-close]');

            openTrigger && this.openQuickView(openTrigger.dataset.target);
            closeTrigger && this.closeQuickView();
            
            event.target === this.wrapper && this.closeQuickView();
        }

        openQuickView(target) {
            const template = this.querySelector(`template[data-target-quick-view="${target}"]`);

            this.wrapper.innerHTML = '';
            this.wrapper.appendChild(template.content.cloneNode(true));
            this.wrapper.classList.add('is-active');
            document.body.classList.add('service-quick-view-open');
            document.body.style.overflow = 'hidden';
        }

        closeQuickView() {
            this.wrapper.classList.remove('is-active');
            this.wrapper.innerHTML = '';
            document.body.classList.remove('service-quick-view-open');
            document.body.style.overflow = '';
        }
    }

    customElements.define('grid-services-items', GridServicesItems);
}
